import { Label, Panel, PanelProps } from "@mcleod/components";
import { DisplayType, DisplayValue, HorizontalAlignment } from "@mcleod/core";

export class TimeBubble extends Panel {
    private labelTime: Label;

    constructor(props?: Partial<PanelProps>) {
        super({
            id: "panelTimeMarkerText",
            margin: 0,
            padding: 0,
            align: HorizontalAlignment.CENTER,
            borderWidth: 1,
            borderColor: "primary.darker",
            borderRadius: 4,
            backgroundColor: "primary.light",
            ...props
        });
        this.createTimeLabel();
        this.add(this.labelTime);
    }

    private createTimeLabel() {
        this.labelTime = new Label({
            id: "labelTimeMarkerTime",
            color: "default.reverse",
            fontBold: true,
            fontSize: "small"
        });
        this.setTime();
    }

    setTime(date: Date = new Date()) {
        this.labelTime.text = DisplayValue.getDateDisplayValue(date, DisplayType.TIME);
    }
}
